module.exports = __webpack_public_path__ + "static/img/25.ea81302b.png";